import { AiFillCaretLeft } from "react-icons/ai"; 
import { BiTrash } from "react-icons/bi"; 
import { BiSave } from "react-icons/bi"; 
import CxIcon from '../../cx/CxIcon';
import React from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxInput from '../../cx/CxInput';
import CxDate from '../../cx/CxDate';
import CxState from '../../cx/CxState';
import CxDialog from '../../cx/CxDialog';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettCalendarHol } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxSnackbar from '../../cx/CxSnackbar';
import * as FxFetch from '../../fx/FxFetch';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxBackdrop from '../../cx/CxBackdrop';

const MxSettCalendarHolForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  const r_snack_save = React.useRef(null);
  const r_snack_required = React.useRef(null);

  let r_form = React.useRef(null);
  
  const [dlgDelete, setDlgDelete] = React.useState(false);
  const [backdrop, setBackdrop] = React.useState(false);
  
  const rf_txTypeCalendarHol = React.useRef(null);
  const rf_dtFrom = React.useRef(null);
  const rf_boNational = React.useRef(null);
  const rf_txRegions = React.useRef(null);
  
  const [storeSettCalendarHol, setStoreSettCalendarHol] = useSessionStorage('StoreSettCalendarHol', StoreSettCalendarHol);

  React.useEffect(() => {
    formLoadCustom();
    // eslint-disable-next-line
  }, []);

  const formLoadCustom = async () => {
    let record = {};
    record['idValue'] = storeSettCalendarHol.itCalendarHol;
    Promise.all([FxFetch.doJsonX('sett/cal_hol/r', record)]).then((result) => {
      let rv = result[0][0];
      if (rv) {
        rf_txTypeCalendarHol.current.setVal(rv.txTypeCalendarHol);
        rf_dtFrom.current.setVal(rv.dtFrom);
        rf_boNational.current.setVal(rv.boNational);
        rf_txRegions.current.setVal(rv.txRegions || '');
      }
    });
  }

  const formDeleteCustom = () => {
    setDlgDelete(true);
  }

  const doDelete = () => {
    setBackdrop(true);

    let record = {};
    record['idValue'] = storeSettCalendarHol.itCalendarHol;
    Promise.all([FxFetch.doJsonF(`sett/cal_hol/d`, null, record)]).then((result) => {
      if (result[0].theValue === 'rv_error') {
      } else {
        navBack();
      }
    });
  }

  const formSaveCustom = async () => {
    if (rf_txTypeCalendarHol.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypeCalendarHol.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_dtFrom.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_dtFrom.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    let filter = {};
    let record = {};
    filter['itCalendarHol'] = storeSettCalendarHol.itCalendarHol;
    record['txTypeCalendarHol'] = rf_txTypeCalendarHol.current.getVal();
    record['dtFrom'] = rf_dtFrom.current.getVal();
    record['boNational'] = rf_boNational.current.getVal();
    record['txRegions'] = rf_txRegions.current.getVal();

    Promise.all([FxFetch.doJsonF("sett/cal_hol/cu", filter, record)]).then((result) => {
      if (result[0]) {
        if (result[0].theStatus === 'OK') {
          storeSettCalendarHol.itCalendarHol = result[0].theValue;
          Promise.all([setStoreSettCalendarHol(storeSettCalendarHol)]).then((result) => {
            r_snack_save.current.setOpen(true);
          });
        }
      }
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.calendars')}: ${trans('field.holiday')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<BiTrash/>} classType="ibs_iconbutton_toolbar" onClick={formDeleteCustom} tooltip={trans('field.delete')} />
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} frontIcon={<AiFillCaretLeft/>} />} classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save_and_exit')} />
          </div>
        }
      >
        <CxInput xref={rf_txTypeCalendarHol} label={trans('field.name')} maxLength="100" required />
        <CxDate xref={rf_dtFrom} label={trans('field.date')} required />
        <CxState mode='checkbox' xref={rf_boNational} label={trans('field.national')} />
        <CxInput xref={rf_txRegions} label={trans('field.regions')} maxLength="1000" />
      </GxForm>

      <CxDialog title={trans('msg.warning')} open={dlgDelete}
        onCancel={() => setDlgDelete(false)}
        onOk={() => { setDlgDelete(false); doDelete() }}
        height='200px'>
        {trans('msg.ask_delete')}
      </CxDialog>

      <CxBackdrop open={backdrop} />
      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} onClose={() => navBack()} />
      <CxSnackbar xref={r_snack_required} severity="error" />

    </div>
  );
}

export default MxSettCalendarHolForm;